import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHome\UpdateFuneralHomeController::__invoke
* @see app/Http/Controllers/FuneralHome/UpdateFuneralHomeController.php
* @route '/api/funeral-home/{funeral_home}'
*/
const UpdateFuneralHomeController = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFuneralHomeController.url(args, options),
    method: 'put',
})

UpdateFuneralHomeController.definition = {
    methods: ["put"],
    url: '/api/funeral-home/{funeral_home}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\FuneralHome\UpdateFuneralHomeController::__invoke
* @see app/Http/Controllers/FuneralHome/UpdateFuneralHomeController.php
* @route '/api/funeral-home/{funeral_home}'
*/
UpdateFuneralHomeController.url = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { funeral_home: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { funeral_home: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            funeral_home: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        funeral_home: typeof args.funeral_home === 'object'
        ? args.funeral_home.id
        : args.funeral_home,
    }

    return UpdateFuneralHomeController.definition.url
            .replace('{funeral_home}', parsedArgs.funeral_home.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHome\UpdateFuneralHomeController::__invoke
* @see app/Http/Controllers/FuneralHome/UpdateFuneralHomeController.php
* @route '/api/funeral-home/{funeral_home}'
*/
UpdateFuneralHomeController.put = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFuneralHomeController.url(args, options),
    method: 'put',
})

export default UpdateFuneralHomeController